// Product
export const isProductLoaded = (state) => { return state.productLoaded }
export const getProductName = (state) => { return state.productName }
export const getProductPrice = (state) => { return state.productPrice }

// Header
export const getHeaderAlignment = (state) => { return state.headerAlignment }
export const isProductNameEnabled = (state) => { return state.productNameEnabled }
export const isProductPriceEnabled = (state) => { return state.productPriceEnabled }

// Gamepad
export const getGamepadButtonsColor = (state) => { return state.gamepadButtonsColor }
export const isArButtonEnabled = (state) => { return state.arButtonEnabled }
export const isResetButtonEnabled = (state) => { return state.resetButtonEnabled }
export const isDimensionsButtonEnabled = (state) => { return state.dimensionsButtonEnabled }
export const isScreenshotButtonEnabled = (state) => { return state.screenshotButtonEnabled }

// AR
export const isArLoading = (state) => { return state.arLoading }

// Glances
export const isGlancedOptionsItem = (state) => { return (state.glancedOptionsItem !== null && state.glancedOptionsItem !== undefined) }
export const getGlancedOptionsItem = (state) => { return state.glancedOptionsItem }

// Error
export const isErrorDisplayed = (state) => { return state.errorDisplayed }
export const getErrorMessage = (state) => { return state.errorMessage }
